<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listSocialSecurity"
        :title-table="$t('Social Security')"
        module="socialSecuritySettingsModule"
        sort-name="nome"
        add-permission="ROLE_PREVIDENCIA_SOCIAL_INSERIR"
        view-permission="ROLE_PREVIDENCIA_SOCIAL_CONSULTAR"
        edit-permission="ROLE_PREVIDENCIA_SOCIAL_ATUALIZAR"
        delete-permission="ROLE_PREVIDENCIA_SOCIAL_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormSocialSecurity v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormSocialSecurity from "./forms/FormSocialSecurity.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormSocialSecurity,
  },
  computed: {
    ...mapState("socialSecuritySettingsModule", {
      listSocialSecurity: (state) => state.listSocialSecurity,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Descrição",
          field: "nome",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "socialSecuritySettingsModule/prepareToEditSocialSecurity",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
